import React from 'react'
import { useLocation } from 'react-router-dom'
import DealReview from '../components/DealReview'

export default function L1DealReview() {
  const { state } = useLocation()
  return <DealReview role="l1" versionId={state?.versionId} proposalId={state?.proposalId} brand={state?.brand} card={state?.card} orderDataFileUri={state?.orderDataFileUri} status={state?.status} />
}
